export default {
  state: {
    keepAlive: [],
  },
  getters: {
    keepAlive: (state) => state.keepAlive,
  },
  mutations: {
    setKeepAlive(state, payload) {
      state.keepAlive = payload;
    },
  },
  actions: {
    keep({ state, commit }, payload) {
      if (!state.keepAlive.includes(payload)) {
        commit("setKeepAlive", state.keepAlive.concat([payload]));
      }
    },
    unkeep({ state, commit }, payload) {
      // console.log(state.keepAlive);
      // console.log(payload);
      // console.log(state.keepAlive.filter(x => x !== payload));
      commit(
        "setKeepAlive",
        state.keepAlive.filter((x) => x !== payload),
      );
    },
    clearKeep({ state, commit }) {
      commit("setKeepAlive", []);
    },
  },
};
